import React from 'react';
import { Spinner } from 'design-system';
import { useObjectPreview } from 'corp/hooks/smartId/useObjectPreview';
import { INamedObjectTypes, ITrainingAttemptPreviewJson } from '@scale/shared/types/lookup';
import IsomorphicLink from 'corp/components/UI/IsomorphicLink';
import { TrainingScenarioType } from '@scale/shared/defaults';

const colorOfTrainingType: Record<TrainingScenarioType, string> = {
  [TrainingScenarioType.Speed]: 'var(--color-ScaleBlue)',
  [TrainingScenarioType.Accuracy]: 'var(--color-RemoGreen)',
  [TrainingScenarioType.AccuracyBenchmark]: 'var(--color-sensor-fusion-cuboids)',
};

const TrainingAttemptPreview: React.FC<{ id: string }> = ({ id }) => {
  const {
    value: trainingAttempt,
    loading,
    error,
  } = useObjectPreview<ITrainingAttemptPreviewJson>(id, INamedObjectTypes.TrainingAttempt);
  if (error) return <span>Sorry, there was an error</span>;
  if (loading) return <Spinner />;
  return (
    <div className="trainingattempt-preview">
      <style jsx>{`
        .trainingattempt-preview__banner {
          font-weight: bold;
          padding: 10px;
          display: flex;
          align-items: center;
        }

        .trainingattempt-preview__thing-list > div {
          display: flex;
        }

        .trainingattempt-preview__thing-list strong {
          color: #666;
          margin-right: 10px;
          min-width: 120px;
          text-align: right;
        }
      `}</style>
      {trainingAttempt && (
        <>
          <div className="trainingattempt-preview__banner">
            <span
              style={{
                fontSize: 'smaller',
                backgroundColor: colorOfTrainingType[trainingAttempt.trainingType],
                color: 'white',
                borderRadius: '14px',
                height: '28px',
                boxSizing: 'border-box',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 10px',
              }}
            >
              {trainingAttempt.trainingType}
            </span>
            <h3 style={{ margin: '0 5px' }}>{id}</h3>
          </div>
          <div className="trainingattempt-preview__body">
            <div className="trainingattempt-preview__thing-list">
              <div>
                <strong>Lookup</strong>
                <IsomorphicLink target="_blank" rel="noopener noreferrer" href={`/lookup/${id}`}>
                  {id}{' '}
                </IsomorphicLink>
              </div>
              <div>
                <strong>Training Scenario</strong>
                <IsomorphicLink
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/lookup/${trainingAttempt.trainingScenario}`}
                >
                  {trainingAttempt.trainingScenario}
                </IsomorphicLink>
              </div>
              {!!trainingAttempt.worker && (
                <div>
                  <strong>Worked On By</strong>
                  <IsomorphicLink
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`/lookup/${trainingAttempt.worker._id}`}
                  >
                    {trainingAttempt.worker.email}
                  </IsomorphicLink>
                </div>
              )}
              <div>
                <strong>Project</strong>
                <IsomorphicLink
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/lookup/${trainingAttempt.project}`}
                >
                  {trainingAttempt.project}
                </IsomorphicLink>
              </div>
              <div>
                <strong>Passed Bar</strong>
                {trainingAttempt.passedBar ? '✅' : '❌'}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default TrainingAttemptPreview;
